export const matchesProteinSelection = (
  productProteins: Array<string> | undefined,
  selectedProteins: Array<string> | undefined
): boolean => {
  if (!selectedProteins || selectedProteins.length === 0) {
    return false;
  }

  const offered = productProteins ?? [];

  return selectedProteins.every(protein => offered.includes(protein));
};
